import { render, staticRenderFns } from "./MenuItemCotizacion.vue?vue&type=template&id=3ceb74ef&scoped=true&"
import script from "./MenuItemCotizacion.vue?vue&type=script&lang=js&"
export * from "./MenuItemCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCotizacion.vue?vue&type=style&index=0&id=3ceb74ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb74ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3ceb74ef', component.options)
    } else {
      api.reload('3ceb74ef', component.options)
    }
    module.hot.accept("./MenuItemCotizacion.vue?vue&type=template&id=3ceb74ef&scoped=true&", function () {
      api.rerender('3ceb74ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemCotizacion.vue"
export default component.exports